import { createActionCreator } from "common/ReduxUtils";
import { StorageCargoActionTypes } from "../StorageCargoAction.types";

export const setContainerId = createActionCreator<string>(
  StorageCargoActionTypes.STORAGE_SET_CONTAINER_ID,
  "containerId"
);
